import moment from 'moment'
import React, { useEffect, useState } from 'react'
import $ from "jquery";
import Imagen from '../../../assets/img/Placeholder.png'
import { Info } from '../../../assets/svg/hartu'
import {
    DATE_FORMAT,
    DATE_FORMAT_DATE_PICKER,
    DATE_HOUR_FORMAT_ES,
    DATE_HOUR_FORMAT_EU,
} from '../../../constants'
import STATES from '../../../constants/states'
import HartuBookingDateForm from '../../../forms/HartuBookingDateForm/HartuBookingDateForm'
import HartuFacilityBookingForm from '../../../forms/HartuFacilityBookingForm/HartuFacilityBookingForm'
import t from '../../../i18n/translations/translations'
import './HartuBookingGrid.css'

const transformDateForDatePicker = (date) => {
    let transformed = moment(date, DATE_FORMAT).format(DATE_FORMAT_DATE_PICKER)
    transformed = moment(transformed).format(DATE_FORMAT_DATE_PICKER)
    return transformed
}

const transformDateForApi = (date) =>
    moment(date).format(DATE_FORMAT_DATE_PICKER)

const addDefaultSrc = (ev) => {
    ev.target.src = Imagen
}

export default function HartuBookingGrid({
    availableDates,
    bookingFormState,
    data,
    datesLoading,
    errorBookingCode,
    facility,
    facilityHoursAvailable,
    formValuesBooking,
    getAvailableDates,
    getAvailableHours,
    hoursLoading,
    instanceID,
    lang,
    defaultPrice,
    paramsDate,
    saveHartuFacilityBooking,
    handleHideDiscount,
}) {
    const dateTransformed = paramsDate
        ? transformDateForDatePicker(paramsDate)
        : null

    const [selectedHour, setSelectedHour] = useState(null)
    const [maxPeople, setMaxPeople] = useState(0)
    const [concurrenceError, setConcurrenceError] = useState('')
    const [dayFocused, setDayFocused] = useState(false)
    const [dates, setDates] = useState(null)
    const [isOpenedBookingForm, setIsOpenedBookingForm] = useState(false)
    const isTributariaBlocked = data && data?.payment_type === 3 && data?.bookedTributaria === false;

    const availableDaysMessage = data && data.available_days_message[lang]
    const description = data && data.description[lang]
    const textInfo = data && data.text_info[lang]
    const timeToPay = data && data.time_to_pay
    const formattedTimeToPay =
        lang === 'es'
            ? moment(timeToPay).format(DATE_HOUR_FORMAT_ES)
            : moment(timeToPay).format(DATE_HOUR_FORMAT_EU)

    const facilityID =
        facility && facility.facility && facility.facility.facilityID
    const maxBookingsDay =
        facility && facility.facility && facility.facility.max_bookings_day
    const maxBookingsMonth =
        facility && facility.facility && facility.facility.max_bookings_month
    const hasCalendarRange = 
        data && data.has_calendar_range
    const hasCalendarRangeConsecutive =
        data && data.has_calendar_range_consecutive

    const handleDateFocus = (value) => {
        setDayFocused(value)
    }

    const confirmDateAndTime = (formData) => {
        if (isTributariaBlocked) return;
        setDates(formData.dates)
        setIsOpenedBookingForm(true)
    }

    const closeForm = () => {
        setDates(null)
        setIsOpenedBookingForm(false);
        handleDateChange(null, null);
    }

    const handleCloseConcurrenceError = () => {
        setConcurrenceError('')
    }

    const handleDateChange = (startDate, endDate) => {
        if (isTributariaBlocked) return;
        const formattedDateStart = transformDateForApi(startDate)
        const formattedDateEnd = transformDateForApi(endDate)
        
        const select = document.querySelector('.hartuTimeSelect__wrapper select');

        if (select) {
            const firstOption = select.options[0];
            select.innerHTML = '';

            if (firstOption) {
                select.appendChild(firstOption);
            }
        }

        if (formattedDateStart && formattedDateEnd && facilityID && instanceID) {
            getAvailableHours({
                facilityID,
                dateStart: formattedDateStart,
                dateEnd: formattedDateEnd,
                instanceID,
            })
        }
    }

    const handleBookingSubmit = (formData) => {
        if (formData) {
            saveHartuFacilityBooking(formData)
        }
    }

    useEffect(() => {
        if (dateTransformed && facilityID && instanceID) {
            handleDateChange(dateTransformed)
        }
    }, [dateTransformed, facilityID, instanceID])

    useEffect(() => {
        if (facilityID) {
            getAvailableDates({
                facilityID,
                instanceID,
            })
        }
    }, [facilityID, instanceID])

    useEffect(() => {
        if (errorBookingCode === 621 || errorBookingCode === 611) {
            setDates(null)
            setIsOpenedBookingForm(false)
            setConcurrenceError(t.dates_no_availables[lang])
        }
    }, [errorBookingCode])

    useEffect(() => {
        if (isOpenedBookingForm === false) {
            setDates(null)
        }
    }, [isOpenedBookingForm])

    useEffect(() => {
        const availability = selectedHour && selectedHour.available_capacity
        setMaxPeople(0)
    }, [selectedHour])

    return data ? (
        <div className="hartuBooking">
            <div className="hartuBookingGrid">
                <div className="hartuBookingGrid-img">
                    <img
                        onError={addDefaultSrc}
                        src={`${data.image}`}
                        alt={data.name[lang]}
                    />
                </div>

                <div className="hartuBookingGrid__row hartuBookingGrid__title-wrapper">
                    <div className="hartuBookingGrid-title">
                        <h1>{data.name[lang]}</h1>
                    </div>
                </div>
                <div className="hartuBookingGrid__content hartuBookingGrid__row">
                    {dates && isOpenedBookingForm ? (
                        <HartuFacilityBookingForm
                            closeForm={closeForm}
                            dates={dates}
                            hideDiscountBanner={true}
                            errorBookingCode={errorBookingCode}
                            id_facility={facilityID}
                            facilityName={data.name[lang]}
                            has_light={data.has_light}
                            has_pellets={data.has_pellets}
                            num_pellets={data.num_pellets}
                            can_pay_later={data.can_pay_later}
                            single_space={data.single_space}
                            phone_mandatory={data.phone_mandatory}
                            id_facility_category={data.id_facility_category}
                            handleSubmit={handleBookingSubmit}
                            initialValues={formValuesBooking}
                            id_instancia={instanceID}
                            lang={lang}
                            maxPeople={maxPeople}
                            payment_type={data.payment_type}
                            state={bookingFormState}
                            tributariaBlocked={isTributariaBlocked}
                        />
                    ) : (
                        <>
                            <HartuBookingDateForm
                                availableDates={availableDates}
                                availableDaysMessage={availableDaysMessage}
                                dateFocused={dayFocused}
                                datesLoading={datesLoading}
                                facilityHoursAvailable={facilityHoursAvailable}
                                facilityID={facilityID}
                                getAvailableHours={handleDateChange}
                                handleCloseConcurrenceError={
                                    handleCloseConcurrenceError
                                }
                                handleSubmitDate={confirmDateAndTime}
                                hoursLoading={hoursLoading}
                                instanceID={instanceID}
                                lang={lang}
                                paramsDate={dateTransformed}
                                setDayFocused={handleDateFocus}
                                state={bookingFormState}
                                handleHideDiscount={handleHideDiscount}
                                maxPeople={maxPeople}
                                setMaxPeople={setMaxPeople}
                                maxBookingsDay={maxBookingsDay}
                                maxBookingsMonth={maxBookingsMonth}
                                setDates={setDates} 
                                hasCalendarRange={hasCalendarRange}
                                hasCalendarRangeConsecutive={hasCalendarRangeConsecutive}
                                isTributariaBlocked={isTributariaBlocked}
                            />

                            <div
                                className="hartuBookingGrid__content--info"
                            >
                                   {isTributariaBlocked && (
                                    <div>
                                        <Info />
                                        <div dangerouslySetInnerHTML={{ __html: textInfo }}  className="hartuBookingGrid__content--payment"/>
                                        <hr />
                                    </div>
                                )}
                                {dates && dates.length > 0 && (
                                    <>
                                        {description && (
                                            <div>
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: description }}
                                                    className="hartuBookingGrid__content--payment"
                                                />
                                                <hr />
                                            </div>
                                        )}
                                        {textInfo && (
                                            <div>
                                                <Info />
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: textInfo
                                                    }}
                                                    className="hartuBookingGrid__content--payment"
                                                />
                                                <hr />
                                            </div>
                                        )}
                                        {defaultPrice != 0 && (
                                            <div className="hartuBookingGrid__content--payment">
                                                <p >{t.limit_date_for_payment[lang]}</p>
                                                {timeToPay == null ? (
                                                    <p>{t.time_to_pay_no_limit[lang]}</p>
                                                ) : (
                                                    <p>{timeToPay}</p>
                                                )}
                                            </div>
                                        )}

                                        {defaultPrice == 0 && (
                                            <p>{t.you_can_make_booking[lang]}</p>
                                        )}
                                    </>
                                )}
                             

                                {/* {!dates && (
                                    <p>{t.pick_a_range_to_book[lang]}</p>
                                )}

                                {dates && !dayFocused && (
                                    <p>{t.pick_a_hour_interval_to_book[lang]}</p>
                                )}

                                {dates && dayFocused && (
                                    <p>{t.pick_a_range_to_book[lang]}</p>
                                )} */}
                            </div>
                        </>
                    )}
                </div>
            </div>
            {bookingFormState === STATES.ERROR_CONCURRENCE &&
                concurrenceError && (
                    <div className="hartuBookingGrid__concurrence-error">
                        {concurrenceError}
                        <span
                            className="hartuBookingGrid__closeBtn"
                            onClick={handleCloseConcurrenceError}
                        >
                            &times;
                        </span>
                    </div>
                )}
        </div>
    ) : null
}
